import React from "react"

const InfoQuestionLoader = () => {
  const bars = Array.from({ length: 3 }, (_, i) => i);

  return (
    <div className="infoquestion-loader">
      {bars.map((i) => (
        <div
          key={i}
          className="infoquestion-bar"
          style={{
            width: `${70 + (i % 2 === 0 ? 0 : -20)}%`, // Alternate long/short widths
            animationDelay: `${i * 0.2}s, ${i * 0.25}s`, // delay for shimmer AND lengthChange
          }}
        ></div>
      ))}
    </div>
  );
}

export default InfoQuestionLoader;
